"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Option = _antd.Select.Option,
  Select = _antd.Select._InternalPanelDoNotUseOrYouWillBeFired;
function handleChange() {}
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    align: 'start'
  }, /*#__PURE__*/_react.default.createElement(Select, {
    defaultValue: "lucy",
    style: {
      width: 120
    },
    onChange: handleChange
  }, /*#__PURE__*/_react.default.createElement(Option, {
    value: "jack"
  }, "Jack"), " ", /*#__PURE__*/_react.default.createElement(Option, {
    value: "lucy"
  }, "Lucy"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "disabled",
    disabled: true
  }, "Disabled"), /*#__PURE__*/_react.default.createElement(Option, {
    value: "Yiminghe"
  }, "yiminghe")), /*#__PURE__*/_react.default.createElement(Select, {
    defaultValue: "lucy",
    style: {
      width: 120
    },
    disabled: true
  }, /*#__PURE__*/_react.default.createElement(Option, {
    value: "lucy"
  }, "Lucy")), /*#__PURE__*/_react.default.createElement(Select, {
    defaultValue: "lucy",
    style: {
      width: 120
    },
    loading: true
  }, /*#__PURE__*/_react.default.createElement(Option, {
    value: "lucy"
  }, "Lucy")), /*#__PURE__*/_react.default.createElement(Select, {
    defaultValue: "lucy",
    style: {
      width: 120
    },
    allowClear: true
  }, /*#__PURE__*/_react.default.createElement(Option, {
    value: "lucy"
  }, "Lucy")));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['controlOutline', 'colorPrimary', 'colorPrimaryHover', 'colorText', 'colorBgElevated', 'colorBgContainer'],
  key: 'select'
};
var _default = exports.default = componentDemo;